import { ReactNode, createContext } from "react";

export type OverlayRendererContext = {
  isOpen: boolean;
  onClose: () => void;
  onAfterClose: () => void;
};

export type OverlayRenderer = (context: OverlayRendererContext) => ReactNode;

export interface EnqueueOverlayConfig {
  namespace?: string;
  renderer: OverlayRenderer;
}

export interface OverlayQueueContextValue {
  enqueueOverlay: (config: EnqueueOverlayConfig) => void;
  replaceCurrentOverlay: (config: EnqueueOverlayConfig) => void;
  isOverlayOpen: (namespace: string) => boolean;
  isOverlayEnqueued: (namespace: string) => boolean;
}

export const OverlayQueueContext =
  createContext<OverlayQueueContextValue | null>(null);
